angular.module('impactx.search').controller('TenderItemCtrl', [
    '$redirect',
    'AppConfiguration',
    'panelService',
    '$routeParams',
    'SearchFilterStorage',
    TenderItemController
]);

function TenderItemController($redirect, AppConfiguration, panelService, $routeParams, SearchFilterStorage) {
    var self = this;

    self.redirectToDetails = function () {
        if ($routeParams.useSetFilterList && SearchFilterStorage.getCurrentFilter()) {
            var filter = JSON.parse(JSON.stringify(SearchFilterStorage.getCurrentFilter()));
            filter.tenderId = {value: self.tender.id};
            filter.dialogFilter = "tender";
            SearchFilterStorage.setTenderFilter(self.tender.id, filter);
        }
        $redirect.redirectTo(null, "tender/" + self.tender.id + (($routeParams.useSetFilter || $routeParams.useSetFilterList) ? "/true" : ""));
    };

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');
    self.getTenderPanelColor = panelService.getTenderPanelColor;
}